import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode,
} from 'react';
import { useNavigate } from 'react-router-dom';
// import { useLocation, useParams, param } from 'react-router-dom';
import api from '../axios/axiosConfig';
import { HttpStatusCode } from 'axios';
import logo from '../assets/Logo_Spott_2.svg';

export type BrandContextType = {
  brandId: string | undefined;
  appId?: string | undefined;
  brandData: any | undefined;
  appLogoFile: any | undefined;
  brandName: string | undefined;
  brandBgColor: string | undefined;
  brandEmailSupportAddress: string | undefined;
  brandEmailSupportPhoneNumber: string | undefined;
  appTermsAndConditionsLink?: string;
  appPrivacyPolicyLink?: string;
  appBgFileId?: string | null;
  appSocialLogin?: string;
  refreshBrandData?: () => void;
};

interface BrandProviderProps {
  children: ReactNode;
  location?: any | undefined;
  params?: any | undefined;
}

const BrandContext = createContext<BrandContextType | undefined>(undefined);
//const routePaths = useLocation().pathname.split('/');

function updateManifest(brandData: any, location: any) {
  //const reactManifest = require("react-manifest")

  // const manifestString = {
  //   "short_name": brandData.appDisplayName,
  //   "name": `${brandData.appDisplayName} - Recarregue seu veículo`,
  //   "icons": [
  //     {
  //       "src": "favicon.ico",
  //       "sizes": "64x64 32x32 24x24 16x16",
  //       "type": "image/x-icon"
  //     },
  //     {
  //       "src": brandData.appLogoFileId ? `/logos/${brandData.appId}.png` : "/logos/236f4cd7-fbab-41a1-acf0-ec1fa9827e34.png",
  //       "type": "image/png",
  //       "sizes": "164x76 192x192 512x512"
  //     }
  //   ],
  //   //"start_url": ".",
  //   "id":`${brandData.appName}`,
  //   "start_url": `/`,
  //   "scope": ".",
  //   "display": "standalone",
  //   "theme_color": brandData.appBgColor ? brandData.appBgColor : "#66C049",
  //   "background_color": brandData.appBgColor ? brandData.appBgColor : "#66C049"
  // }

  //const stringManifest = JSON.stringify(manifestDetails);
  //const blob = new Blob([stringManifest], { type: "application/json" });
  //const manifestURL = URL.createObjectURL(blob);

  document.title = brandData.appDisplayName;
  document
    .querySelector('#description-placeholder')
    ?.setAttribute('content', brandData.appDisplayName);
  //document.querySelector("#apple-touch-icon")?.setAttribute("href", brandData.appLogoFileId ? `${process.env.REACT_APP_API_URL}/ImageFile/${brandData.appLogoFileId}` : "logo192.png");
  //document.querySelector("#manifest-placeholder")?.setAttribute("href", manifestURL);

  // const manifestElement = document.querySelector("#manifest-placeholder");

  // console.log('location: ' + location.pathname);
  // manifestElement?.setAttribute(
  //   "href",
  //   "data:application/json;charset=utf-8," + encodeURIComponent(JSON.stringify(manifestString))
  // );
  //reactManifest.update(manifestDetails, "#manifest-placeholder");
}

function getPWADisplayMode() {
  // const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
  // if (document.referrer.startsWith('android-app://')) {
  //   return 'twa';
  // } else if (navigator. || isStandalone) {
  //   return 'standalone';
  // }
  // return 'browser';
}

export const BrandProvider = ({
  children,
  location,
  params,
}: BrandProviderProps) => {
  const [brandId, setBrandId] = useState<string | undefined>();
  const [brandData, setBrandData] = useState<any | undefined>();
  const [appSocialLogin, setAppSocialLogin] = useState<any | undefined>();
  const [brandName, setBrandName] = useState<string | undefined>();
  const [appLogoFile, setAppLogoFile] = useState<any | undefined>();
  const [appBgFileId, setAppBgFileId] = useState<string | null>(null);
  const [brandBgColor, setBrandBgColor] = useState<string | undefined>();
  const [brandEmailSupportAddress, setBrandEmailSupportAddress] = useState<
    string | undefined
  >();
  const [brandEmailSupportPhoneNumber, setBrandEmailSupportPhoneNumber] =
    useState<string | undefined>();

  const isInstaledApp = window.matchMedia('(display-mode: standalone)').matches;
  //const navigate = useNavigate();

  // Função para buscar dados da aplicação (pode ser chamada para atualizar)
  const getData = async (brandNameParam: string) => {
    api
      .get(`/Applications/${brandNameParam}`)
      .then((response) => {
        console.log('set X-Brand-ID: ' + response.data?.appBrand);
        console.log('BrandData received:', {
          appId: response.data?.appId,
          appBrand: response.data?.appBrand,
          appWalletTopUpConfig: response.data?.appWalletTopUpConfig,
        });
        api.defaults.headers.common['X-Brand-ID'] = response.data?.appBrand;
        setBrandId(response.data?.appId);
        setBrandBgColor(
          response.data?.appBgColor ? response.data?.appBgColor : '#3CCC10'
        ); //
        setBrandEmailSupportAddress(response.data?.appEmailSupportAddress);
        setBrandEmailSupportPhoneNumber(
          response.data?.appEmailSupportPhoneNumber
        );
        setBrandData(response.data);
      })
      .catch((error) => {
        console.log(error.response?.status);
        if (error.response?.status === HttpStatusCode.NotFound) {
          const currentBrand = location.pathname.split('/')[1];
          if (currentBrand !== 'spott') {
            const remainingPath = location.pathname.replace(/^\/[^\/]+/, '') || '/';
            window.location.replace(`/spott${remainingPath}`);
          }
        } else
          alert(
            'Não foi possivel obter os dados do aplicativo. Por favor tente novamente.'
          );
      });
  };

  // Função pública para refetch dos dados
  const refreshBrandData = () => {
    if (brandName) {
      console.log('Refreshing brand data for:', brandName);
      getData(brandName);
    }
  };

  useEffect(() => {
    if (!brandData) return;

    const fetchBrandImages = async (brandData: any) => {
      if (brandData.appLogoFileId) {
        api
          .get(`Files/${brandData.appLogoFileId}`)
          .then((response) => {
            // setTimeout(() => {
            setAppLogoFile(response.data.fileData);
            // }, 5000);
          })
          .catch((error) => {
            setAppLogoFile(logo);
            console.log('fetch appLogoFile error:', error.response.status);
          });
      } else setAppLogoFile(logo);
      setAppBgFileId(brandData.appBgFileId);
    };

    fetchBrandImages(brandData);

    //const favicon = document.getElementById("favicon");
    updateManifest(brandData, location);
  }, [brandData]);

  useEffect(() => {
    if (brandName == null) return;

    console.log('brandName: ' + brandName);
    getData(brandName);
  }, [brandName]);

  useEffect(() => {
    const storedBrandName = localStorage.getItem('brandName');
    const storedAppSocialLogin = localStorage.getItem('appSocialLogin');
    const brandPath: string | null = location?.pathname?.split('/')[1];

    if (!brandPath) {
      window.location.replace(
        storedBrandName ? `/${storedBrandName}/` : `/spott/`
      );
    } else if (brandPath === 'ch') {
      window.location.replace(
        storedBrandName
          ? `/${storedBrandName}${location.pathname}`
          : `/spott${location.pathname}`
      );
      return;
    }

    const brandName = storedBrandName
      ? storedBrandName
      : brandPath
      ? brandPath
      : 'spott';

    if (storedBrandName && brandPath !== storedBrandName) {
      window.location.replace(`/${storedBrandName}`);
      return;
    }

    //navigate(`/${storedBrandName}`, { replace:true });
    console.log('isInstaledApp: ' + isInstaledApp);
    console.log('brandName: ' + brandName);
    console.log('storedAppSocialLogin: ' + storedAppSocialLogin);
    setBrandName(brandName);
    setAppSocialLogin(storedAppSocialLogin);

    //let effectiveBrandId = routePaths[1] || process.env.REACT_APP_DEFAULT_BRAND_ID || 'spott';
  }, []);

  return (
    <BrandContext.Provider
      value={{
        brandId,
        appId: brandId,
        brandData,
        appLogoFile,
        appBgFileId,
        brandName,
        brandBgColor,
        brandEmailSupportAddress,
        brandEmailSupportPhoneNumber,
        appTermsAndConditionsLink: brandData?.appTermsAndConditionsLink,
        appPrivacyPolicyLink: brandData?.appPrivacyPolicyLink,
        appSocialLogin,
        refreshBrandData,
      }}
    >
      <>{brandName !== undefined && children}</>
    </BrandContext.Provider>
  );
};

export const useBrandContext = (): any => {
  const context = useContext(BrandContext);
  if (!context) {
    throw new Error('useBrand must be used within a BrandProvider');
  }

  return context;
};
